import type { JSX } from "react";
import { useNavigate } from "react-router-dom";
import { Screen } from "../components/ui/editorial/Screen.js";
import { Topline } from "../components/ui/editorial/Topline.js";

export function Terms(): JSX.Element {
  const navigate = useNavigate();

  return (
    <Screen tone="paper">
      <div className="px-[22px] pt-[48px]">
        <Topline left="COMPANION" right="соглашение" />
      </div>

      <div className="flex flex-1 flex-col px-[22px] pt-[30px] pb-[24px]">
        <button
          type="button"
          onClick={() => {
            navigate(-1);
          }}
          className="self-start editorial-meta text-ink/55 hover:text-ink transition-colors"
        >
          ← назад
        </button>

        <div className="mt-[22px] editorial-kicker text-accent">Пользовательское соглашение</div>

        <h1 className="mt-[14px] font-display font-light leading-[1] tracking-[-0.028em] text-ink text-[40px]">
          Простые <em className="italic text-velvet">правила</em>
          <br />
          совместной работы.
        </h1>

        <div className="mt-[28px] font-display font-light text-[16px] leading-[1.58] text-ink/85 space-y-[14px]">
          <p>
            Спутник — это сервис знакомств с редакторским подбором, без свайпов и таймеров. Спутник
            подбирает вам людей на основе ваших ответов — вы откликаетесь на присланные профили в
            удобном темпе.
          </p>

          <p>
            <strong className="font-normal text-ink">Возраст:</strong> сервис доступен людям от 18
            лет. Мы можем запросить подтверждение возраста, если возникнут сомнения.
          </p>

          <p>
            <strong className="font-normal text-ink">Честность анкеты:</strong> мы просим отвечать
            по-настоящему. Фиктивные анкеты, чужие фото, коммерческие предложения и спам приводят к
            блокировке без возврата средств.
          </p>

          <p>
            <strong className="font-normal text-ink">Бета-период:</strong> сейчас сервис работает в
            бета-режиме — бесплатно, в Москве. Мы можем менять функции, темп подбора и дизайн без
            предварительного уведомления. Платные тарифы появятся позже, о переходе предупредим
            заранее.
          </p>

          <p>
            <strong className="font-normal text-ink">Спутник и редактор:</strong> «Спутник» — голос
            сервиса на знакомстве: он задаёт вопросы, чтобы собрать ваш портрет. Дальше вас ведёт
            закреплённый редактор — живой человек с именем (например, Марк&nbsp;Г.). Именно он пишет
            письма, подбирает пары и отвечает на вопросы. Языковые модели помогают с черновиками;
            финальный отбор — всегда за редакцией.
          </p>

          <p>
            <strong className="font-normal text-ink">Пауза и удаление:</strong> в любой момент в
            «редакции» — пауза переписки или полное удаление профиля.
          </p>

          <p>
            <strong className="font-normal text-ink">Ответственность:</strong> мы знакомим — но за
            саму встречу, переписку и дальнейшие отношения отвечаете вы. Будьте вежливы друг с
            другом.
          </p>
        </div>

        <p className="mt-[32px] editorial-meta text-ink/50">Редакция № I · апрель 2026</p>
      </div>
    </Screen>
  );
}
